import React, { useEffect } from 'react';
import { Button } from 'rsuite';
import './LandingPage.scss';
import HotelTraderLogo from '../assets/HotelTrader_White.svg';
import LeftSideBg from '../assets/leftside_bg.svg';
import RightSideBg from '../assets/rightside_bg.svg';
import { initiateApaleoAuth } from '../utils/apaleoAuth';
import { useNavigate } from 'react-router';
import { useAuth } from 'contexts/AuthContext';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/');
    } else {
      navigate('/property-selection');
    }
  }, [isAuthenticated, navigate]);

  const handleConnectClick = () => {
    initiateApaleoAuth();
  };
  return (
    <div className="landing-page">
      <img src={LeftSideBg} alt="" className="bg-left" />
      <img src={RightSideBg} alt="" className="bg-right" />

      <div className="landing-content">
        <div className="landing-header">
          <div className="content">
            <div className="hotel-trader">
              <div className="ht-logo">
                <img
                  src={HotelTraderLogo}
                  alt="Hotel Trader"
                  className="ht-icon"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="landing-title">
          Start using <span>Hotel Trader</span> with your <span> apaleo </span>{' '}
          account
        </div>

        <div className="landing-description">
          You're about to disconnect your apaleo properties from HotelTrader.
          This process will allow you to select which properties you'd like to
          remove from our system.
        </div>

        <div className="landing-warning">
          <span><i></i> Important: </span> Disconnecting properties will stop revenue
          management services for those properties. You can always reconnect
          them later if needed.
        </div>

        <div className="landing-actions">
          <Button
            className="connect-button"
            appearance="primary"
            size="lg"
            onClick={handleConnectClick}
          >
            Continue to Disconnect
          </Button>
        </div>

        <div className="landing-footer">
          <div className="landing-footer-content">
            <p className="landing-footer-text">
              <span>Secure Process:</span> You'll be redirected to apaleo's
              secure authorizatio page to verify your account and select
              properties to disconnect.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
